<template>
  <SCookiePopup :domain="useHost()" />
</template>

<script setup lang="ts">
import { useHead } from "#app";

import { SCookiePopup } from "@solvari/components";

import { useHost } from "~/shared/composables/useHost.ts";

useHead({
  script: [
    {
      tagPosition: "bodyClose",
      textContent: `
        if (!document.cookie.match(/(?:^| )solvariCookieConsent=([^;]*)/)) {
          document.getElementById("cookie-popup").style.display = "grid";
        }`,
    },
  ],
});
</script>
